import { useEffect, useState } from 'react';
import { client } from '../client';

export const useSkillsData = () => {
  const [skills, setSkills] = useState([]);

  // Effects hook
  useEffect(() => {
    const skillsQuery = '*[_type == "skills"]';

    client.fetch(skillsQuery).then((data) => {
      setSkills(data);
    });
  }, []);

  return skills;
};
